import { pick } from 'lodash-es'

import { getFormValue } from '../utils'

export const prepareValuesForPreview = (eventType, formValues) => {
  const { lockTimezoneStatus } = formValues

  if (lockTimezoneStatus === undefined) {
    return pick(eventType, ['lock_timezone_enabled', 'lock_timezone_content'])
  }
  const lockTimezoneEnabled = getFormValue(eventType.lock_timezone_enabled, lockTimezoneStatus === 'locked')

  return {
    lock_timezone_enabled: lockTimezoneEnabled,
    lock_timezone_content: lockTimezoneEnabled ? getFormValue(eventType.lock_timezone_content, formValues.lockTimezoneContent) : '',
  }
}
